export default __webpack_public_path__ + "static/media/gummies2.9c9962a3.png";